import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import CustomModal from "../../components/CustomModal";
import qs from "qs";
import Paging from "../../components/Paging";
import { FOTO_CONTENT_HOST } from "../../constants/siteConfig";
import Select from "react-select";
import ImageZoom from "react-medium-image-zoom";
import ModalHelp from "../../components/ModalHelp";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import CStatusModalSoal from "../../components/CStatusModalSoal";
import { Badge } from "reactstrap";
import { array } from "prop-types";

const tipe_soal = [
  { value: "", label: "Pilih Tipe" },
  { value: "single", label: "Single Option" },
  { value: "essay", label: "Essay" },
];

class Lists extends React.Component {
  constructor() {
    super();
    this.state = {
      dataSoal: [],
        dataListSoal : [],
      dataMapel: [],
      dataGuru: [],
      exam_cat_id: 0,
      pageCount: 0,
      currentPage: 0,
      isLoading: false,
      isDetailExamLoading: false,
      isModalShow: false,
      question_id: "",
      mapel_id: "",
      user_id: "",
      isAll: false,
      question_type: "",
      tutorial: "",
      isModalHelpShow: false,
      sortName: "",
      sortOrder: "",
      startNo: 1,
      selected: [],
        isModalSoal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
    this.handleChangeOptionTrue = this.handleChangeOptionTrue.bind(this);
    this.handleChangeOptionAll = this.handleChangeOptionAll.bind(this);
    this.toggleModalHelp = this.toggleModalHelp.bind(this);
      this.toggleModalSoal = this.toggleModalSoal.bind(this);
  }

    toggleModalSoal() {
        this.setState({
            isModalSoal: !this.state.isModalSoal
        });
    }

  handleChangeMultiSelect(stateName, text) {
    this.setState({ [stateName]: text });
  }

  toggleModalHelp() {
    this.setState({ tutorial: "https://www.youtube.com/embed/jIFNdaV3XrU" });

    this.setState({ isModalHelpShow: !this.state.isModalHelpShow });
  }

  handleChangeOptionTrue(event, siswa_id) {
    this.selected = this.selected || {};
    if (event.target.checked) {
      this.selected[siswa_id] = true;
    } else {
      delete this.selected[siswa_id];
    }
  }

  handleChangeOptionAll(event) {
    this.selected = this.selected || {};
    if (event.target.checked) {
      this.setState({
        isAll: !this.state.isAll,
      });
      this.state.dataSoal.map((item) => {
        this.selected[item.question_id] = true;
      });
    } else {
      this.setState({
        isAll: false,
      });
      this.state.dataSoal.map((item) => {
        delete this.selected[item.question_id];
      });
    }
  }

  handlePageClick(data) {
    let selected = data.selected; // zero based index

    this.setState({ currentPage: selected }, () => {
      this.loadData();
    });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  loadData() {
    this.setState({ isLoading: true });

    axios({
      method: "post",
      url: "/soal",
      data: qs.stringify({
        id: localStorage.SISMART_USER_ID,
        mapel: this.state.mapel_id,
        user: this.state.user_id,
        question_type: this.state.question_type,
        page: this.state.currentPage + 1,
        sortName: this.state.sortName,
        sortOrder: this.state.sortOrder,
      }),
    })
      .then((response) => {
        const result = response.data;
        if (result.success === true) {
          this.setState({
            dataSoal: result.data.data,
            pageCount: result.data.last_page,
            isLoading: false,
            startNo: result.data.from,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
          });
        } else {
          Alert.error(result.message, {
            position: "bottom-right",
          });
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
      });
  }

  toggleModal(e) {
    this.setState({
      modalShow: !this.state.modalShow,
      question_id: e,
    });
  }

  handleHapusButton() {
    this.setState({ isButtonLoading: true });

    const url = "/soal/delete";

    let newState = {
      locale: "id",
      platform: "web",
      user_id: localStorage.SISMART_USER_ID,
      question_id: this.state.selected,
      exam_id: this.props.match.params.exam_id,
    };

    axios({
      method: "post",
      url: url,
      data: qs.stringify(newState),
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
            if (result.data.length > 0){
            this.setState({
                dataListSoal: result.data,
                isLoading: false
            });
            this.toggleModalSoal();
            this.selected=[];
            this.loadData();
        }else{
            Alert.success(result.message, {
                position: "bottom-right",
            });
            this.setState({
                dataListSoal: result.data,
                isLoading: false
            });
            this.selected=[];
            this.loadData();
        }
        } else {
          if (Array.isArray(result.message)) {
            result.text.map((item) => {
              Alert.error(item, {
                position: "bottom-right",
              });

              return true;
            });
          } else {
            Alert.error(result.message, {
              position: "bottom-right",
            });
          }

          this.setState({ isButtonLoading: false });
        }
      })

      .catch((error) => {
        console.log(error);
        this.setState({ isButtonLoading: false });
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
      });

    this.setState({ modalShow: false });
    // window.location.reload()
  }

  loadDataMapel() {
    axios
      .post("/mapel")
      .then((response) => {
        return response.data.mapelexport.map((item) => ({
          value: item.mapel_id,
          label: item.mapel_nama,
        }));
      })
      .then((result) => {
        result = result.slice(0);
        result.splice(this.state.result, 0, {
          value: "",
          label: "Pilih Mapel",
        });

        this.setState({
          dataMapel: result,
        });
      })
      .catch((error) => {
        console.log("Mapel Undefinded", {
          position: "bottom-right",
        });
      });
  }

  loadDataGuru() {
    const params = qs.stringify({
      level: "guru",
    });

    axios
      .post("/user?" + params)
      .then((response) => {
        return response.data.data.map((item) => ({
          value: item.user_id,
          label: item.user_nama,
        }));
      })
      .then((result) => {
        result = result.slice(0);
        result.splice(this.state.result, 0, { value: "", label: "Pilih Guru" });

        this.setState({
          dataGuru: result,
        });
      })
      .catch((error) => {
        console.log(error, {
          position: "bottom-right",
        });
      });
  }

  componentDidMount() {
    if (localStorage.SISMART_USER_LEVEL !== "administrator") {
      this.props.history.replace("/dashboard");
    }

    this.loadData();
    this.loadDataMapel();
    this.loadDataGuru();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.mapel_id !== this.state.mapel_id ||
      prevState.user_id !== this.state.user_id ||
      prevState.question_type !== this.state.question_type ||
      prevState.sortName !== this.state.sortName ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.loadData(),
        this.setState({
          isAll: false,
        });
    }
  }

  onSortChange(sortName, sortOrder) {
    this.setState({
      sortName,
      sortOrder,
    });
  }

  onRowSelect(row, isSelected, e) {
    let newState = [...this.state.selected]; // make a separate copy of the array
    let index = newState.indexOf(row.question_id);

    if (index !== -1) {
      newState.splice(index, 1);
      this.setState({ selected: newState });
    } else {
      newState.push(row.question_id);
      this.setState({ selected: newState });
    }
  }

  onSelectAll(isSelected, rows) {
    let newState = [...this.state.selected]; // make a separate copy of the array
    if (isSelected) {
      for (let i = 0; i < rows.length; i++) {
        newState.push(rows[i].question_id);
      }

      this.setState({ selected: newState });
    } else {
      this.setState({ selected: [] });
    }
  }

  render() {
    const strt = this.state.startNo;
    const url = this.props.match.url;

    function indexN(cell, row, enumObject, index) {
      return <div>{index + strt}</div>;
    }

    function formatMapel(cell, row, enumObject, index) {
      return row.mapel != null ? row.mapel.mapel_nama : "-";
    }

    function formatTags(cell, row, enumObject, index) {
      const kets = row.keterangan !== null ? row.keterangan.split(" ") : [];

      if (kets.length > 0) {
        return (
          <div>
            {kets.map(function (i, index) {
              return [
                <br key={index + "break"} />,
                <span className="badge badge-danger" key={index}>
                  {i}
                </span>,
              ];
            })}
          </div>
        );
      } else {
        return <span className="badge badge-danger">{row.keterangan !== null ? row.keterangan : 'No Tags'}</span>;
      }
    }

    function formatSoal(cell, row, enumObject, index) {
      return (
        <div>
          <span className="badge badge-danger">
            {row.mapel != null ? row.mapel.mapel_nama : ""}
          </span>

          <div
            dangerouslySetInnerHTML={{
              __html: row.question_text,
            }}
          />
        </div>
      );
    }

    function formatImage(cell, row, enumObject, index) {
      if (row.question_pict !== null) {
        return (
          <ImageZoom
            image={{
              src: "data:" + row.qtype_pict + ";base64," + row.question_pict,
              className: "img",
              style: { width: "50px" },
            }}
          />
        );
      } else {
        return (
          <ImageZoom
            image={{
              src: "./noimage.gif",
              className: "img",
              style: { width: "50px" },
            }}
          />
        );
      }
    }

    function formatOpsi(cell, row, enumObject, index) {
      return (
        <div>
          <NavLink
            to={`${url}/edit/${row.question_id}`}
            className="btn btn-secondary btn-sm"
          >
            Edit
          </NavLink>
          &nbsp;&nbsp;
          <NavLink
            to={`${url}/detail/${row.question_id}`}
            className="btn btn-secondary btn-sm"
          >
            Detail Soal
          </NavLink>
          &nbsp;&nbsp;
        </div>
      );
    }

    const options = {
      clearSearch: true,
      searchPosition: "left",
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
      onSortChange: this.onSortChange.bind(this),
    };

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      bgColor: "pink",
      onSelect: this.onRowSelect.bind(this),
      onSelectAll: this.onSelectAll.bind(this),
    };

    return (
      <div className="col-sm-12">

          <CStatusModalSoal
              modalHeaderText="Verifikasi hapus Soal"
              modalBodyText="List Soal di bawah ini tidak bisa dihapus karena sudah digunakan untuk ujian ..!"
              modalSubmitText="Ok"
              handleSubmit={() => this.handleHapusButton()}
              dataListSoal={this.state.dataListSoal}
              toggleModalSoal={this.toggleModalSoal}
              isShow={this.state.isModalSoal}
          />

        <ModalHelp
          isShow={this.state.isModalHelpShow}
          toggleModal={this.toggleModalHelp}
          handleSubmit={this.handleSubmitDeleteButton}
          modalHeaderText="Tutorial Penggunaan Fitur"
          modalBodyText={this.state.tutorial}
          modalSubmitText="Ya"
        />
        <CustomModal
          modalHeaderText="Hapus"
          modalBodyText="Anda yakin ingin menghapus?"
          modalSubmitText="Hapus"
          handleSubmit={() => this.handleHapusButton()}
          toggleModal={this.toggleModal}
          isShow={this.state.modalShow}
        />
        <div className="card">
          <div className="card-header">
            Data Pertanyaan
            <button
              type="button"
              title="Tutorial"
              className="btn btn-danger btn-sm"
              style={{ float: "right" }}
              onClick={() => {
                this.toggleModalHelp();
                // this.setState({ tutorial: levelName});
              }}
            >
              <i className="fa fa-question-circle" s></i>
            </button>
          </div>
          <div className="card-header">
            <NavLink
              to={`${this.props.match.url}/add`}
              className="btn btn-primary "
              style={{ marginTop: "2px" }}
            >
              Tambah Pertanyaan
            </NavLink>
            &nbsp;&nbsp;
            <NavLink
              to={`${this.props.match.url}/import`}
              className="btn btn-primary "
              style={{ marginTop: "2px" }}
            >
              Import Soal
            </NavLink>
          </div>

          <div className="card-block">
            <div className="form-group row">
              <div className="col-md-3">
                <Select
                  name="user_id"
                  simpleValue
                  value={this.state.user_id.toString()}
                  clearable={false}
                  placeholder={"Pilih Guru"}
                  onChange={(text) =>
                    this.handleChangeMultiSelect("user_id", text)
                  }
                  options={this.state.dataGuru}
                  isLoading={this.state.isLoading}
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="mapel_id"
                  simpleValue
                  value={this.state.mapel_id.toString()}
                  clearable={false}
                  placeholder={"Pilih Mapel"}
                  onChange={(text) =>
                    this.handleChangeMultiSelect("mapel_id", text)
                  }
                  options={this.state.dataMapel}
                  isLoading={this.state.isLoading}
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="question_type"
                  simpleValue
                  value={this.state.question_type.toString()}
                  clearable={false}
                  placeholder={"Pilih Type"}
                  onChange={(text) =>
                    this.handleChangeMultiSelect("question_type", text)
                  }
                  options={tipe_soal}
                  isLoading={this.state.isLoading}
                />
              </div>
              <div className="col-md-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm  float-right"
                  onClick={() => {
                    this.toggleModal();
                  }}
                >
                  Hapus
                </button>
              </div>
            </div>

            {this.state.isLoading ? (
              "Memuat Data..."
            ) : this.state.dataSoal.length === 0 ? (
              "Data Kosong..."
            ) : (
              <div>
                <BootstrapTable
                  data={this.state.dataSoal}
                  striped
                  hover
                  remote
                  options={options}
                  selectRow={selectRowProp}
                >
                  <TableHeaderColumn
                    width="50"
                    dataField="question_id"
                    dataFormat={indexN}
                    isKey
                  >
                    No
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="250"
                    dataField="question_text"
                    dataSort
                    dataFormat={formatSoal}
                    tdStyle={{ whiteSpace: "normal" }}
                  >
                    Pertanyaan
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="100"
                    dataField="question_pict"
                    dataFormat={formatImage}
                  >
                    Gambar
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="100"
                    dataField="keterangan"
                    dataSort
                    dataFormat={formatTags}
                  >
                    Tags
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="question_type" width="100">
                    Type
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="user_nama" dataSort width="150">
                    Guru
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="any" dataFormat={formatOpsi} width="150">
                    Opsi
                  </TableHeaderColumn>
                </BootstrapTable>
                <hr />

                <Paging
                  handlePageClick={this.handlePageClick.bind(this)}
                  pageCount={this.state.pageCount}
                  currentPage={this.state.currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Soal/Lists.js